import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CombinedCoverImageAndContentComponent} from '@aviary/components/combined-cover-image-and-content/combined-cover-image-and-content.component';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {Checkout} from '@store/checkouts/checkouts.types';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';

@Component({
  selector: 'px-checkout-detail',
  host: {
    class: 'flex flex-row items-center w-full',
  },
  template: `
    <mx-combined-cover-image-and-content [catalogRecord]="selectors.buildCatalogRecordFor(checkout) | select"
                                         [coverWidthRem]="3.75" [coverHeightRem]="5" class="w-full">
      <div class="text-title-large">{{ selectors.itemTitleFor(checkout) | select }}</div>
      <div>{{ selectors.identifierFor(checkout) | select }}</div>
      <div>{{ selectors.itemMediaTypeFor(checkout) | select }}</div>
      @if (showDueDate) {
        <div>
          Due: <span [class.text-error]="selectors.overDueFor(checkout) | select">{{ selectors.dueDateFor(checkout) | select | format: 'DATE_ONLY' }}</span>
        </div>
      }
    </mx-combined-cover-image-and-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CombinedCoverImageAndContentComponent, FormatPipe, SelectPipe]
})
export class CheckoutDetailComponent {
  @Input({required: true}) checkout: Checkout;
  @Input() showDueDate: boolean = true;
  public readonly selectors = CheckoutsSelectors.StatelessCheckouts;
}
